export * from './message-template.interface';
